module.exports = __webpack_public_path__ + "static/media/bgshape.2b3a1dd1.png";